import React, { PureComponent } from 'react';
import WND from './WND.js';
import ICONS from './ICONS';
import MENUBAR from './menus/MENUBAR';
import './IEXPLORE.css';

import STATUSBAR from './STATUSBAR.js';
import BUTTON from './BUTTON.js';

let menu = [
    { text: "File", accel: "F" },
    { text: "Edit", accel: "E" },
    { text: "View", accel: "V" },
    { text: "Go", accel: "G" },
    { text: "Favorites", accel: "a" },
    { text: "Help", accel: "H" }
];

let homeUrl = "https://waller.is/";

class IEXPLORE extends WND {
    constructor(props) {
        super(props);

        this.state.currentUrl = null;
    }

    applicationContent() {
        let statusBarParts = [ "", "", "" ];
        let toolbarButtons = ["BACK", "FWD", "STOP", "RFSH", "HOME", "SRCH"/*, "FAVS"*/];
        let grabber = <div className="ie-grabber"><div></div><div></div></div>;
        let clickHandlers = {
            HOME: () => this.frame.src = "/wwwroot/index.html",
            SRCH: () => this.frame.src = "http://web.archive.org/web/19961223150621/http://www8.yahoo.com/"
        };

        return <STATUSBAR parts={statusBarParts}>
            <div className="iexplore">
                <MENUBAR menu={menu} />

                <div className="ie-toolbar" style={{backgroundImage: "url(" + ICONS.IE_BG + ")"}}>
                    <div className="ie-toolbar-part ie-btns">
                        {grabber}
                        <div className="ie-btns-container">{toolbarButtons.map((name, i) => {
                            return <BUTTON key={i} onPress={clickHandlers[name]}>
                                <img src={ICONS["IE" + name]} className="inactive" />
                                <img src={ICONS["IE" + name + "_A"]} className="active" />
                            </BUTTON>;
                        })}</div>
                        <img src={ICONS.IEICON} />
                    </div>
                    <div className="ie-toolbar-part ie-address">
                        {grabber}
                        <div className="ie-address-text">Address</div>
                        <div className="ie-address-field">https://waller.is/</div>
                    </div>
                </div>

                <div className="ie-frame">
                    <iframe 
                        src="/wwwroot/index.html"
                        ref={(r) => this.frame = r}
                        className="web-frame"
                        onMouseEnter={() => {
                            window.WINAPI.SetCursorVisible(false);
                        }}
                        onMouseLeave={() => {
                            window.WINAPI.SetCursorVisible(true);
                        }}></iframe>
                </div>
            </div>
        </STATUSBAR>;
    }

    icon() {
        return ICONS.HTML;
    }

    title() {
        return "Microsoft Internet Explorer"; // todo web page title
    }
}

export default IEXPLORE;


// WEBPACK FOOTER //
// ./src/walleris/IEXPLORE.js